import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-120" data-mp="bq9f2pruf808">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:bottom-5 sm:left-auto sm:right-5 sm:px-0 sm:pb-0" initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-121" data-mp="195wsldarnr9y">
          <a href={CHECKOUT_URL} onClick={() => window.fbq?.("track", "InitiateCheckout")} className="animate-cta-shake flex w-full items-center justify-center gap-2.5 rounded-2xl bg-cta px-5 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-6px_rgba(21,128,61,0.7)] ring-2 ring-white hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:w-auto sm:px-7" data-id="element-122" data-mp="2f2zgrjqzd4xd">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-123" data-mp="1ieb8vg8zay1o" />
            Get instant access — $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}